// The name a provider sees for a customer (owner, 2026-09-27): the centre's own "Nome cliente"
// (describedName = customers_providers.name), else the part of the email before "@". Never
// user.name — that is the customer's own username in their app. Same rule as the API's
// core/customerName.ts.
export const customerDisplayName = ({ describedName, email } = {}) => (describedName || '').trim() || (email || '').split('@')[0].trim() || '';
